<template>
  <div class="tw:flex tw:bg-blue-100 tw:rounded tw:p-2 tw:items-center tw:justify-start">
    <i18n-t
      v-if="partnersOptions.length === 1"
      tag="p"
      keypath="connectivity_provider_info"
      class="tw:flex tw:gap-1 tw:landing:items-center tw:landing:justify-center tw:flex-wrap tw:landing:flex-nowrap"
    >
      <template #partnerName>
        <div class="tw:flex tw:items-center">
          <strong>{{ activePartnersData?.[0]?.partnerName }}</strong>
          <UiTooltip
            tooltip-position="top"
            :label="$t('connectivity_provider_info_tooltip', { partnerName: activePartnersData?.[0].partnerName })"
            class="tw:cursor-pointer tw:flex"
          >
            <InformationOutline class="tw:fill-none tw:stroke-gray-700 tw:h-5 tw:w-5 tw:ml-1" />
          </UiTooltip></div
      ></template>
    </i18n-t>

    <i18n-t
      v-if="partnersOptions.length > 1"
      tag="p"
      keypath="connectivity_provider_info"
      class="tw:flex tw:landing:items-center tw:flex-wrap tw:landing:flex-nowrap tw:justify-center tw:flex-col tw:landing:flex-row tw:gap-1"
    >
      <template #partnerName>
        <div class="tw:flex tw:items-center">
          <BaseSelect
            id="'select-connectivity-partner'"
            data-testid="rate-connect-connection-select"
            class="tw:md:min-w-[160px] tw:mt-2 tw:md:mt-0 tw:font-bold"
            :value="selectedPartner.value"
            :options="partnersOptions"
            size="medium"
            display-text-key="displayText"
            @onChange="e => setSelectedPartner(e)"
          />
          <UiTooltip
            tooltip-position="top"
            :label="$t('connectivity_provider_info_tooltip', { partnerName: selectedPartner?.partnerName })"
            class="tw:cursor-pointer tw:flex tw:flex-col tw:mr-2"
          >
            <InformationOutline class="tw:fill-none tw:stroke-gray-700 tw:h-5 tw:w-5 tw:ml-2" />
          </UiTooltip>
        </div>
      </template>
    </i18n-t>
  </div>
</template>
<script setup>
import { computed, watch } from 'vue'

import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import BaseSelect from '@/components/BaseSelect.vue'

import { usePartners } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSetup } from '@/components/rateConnect/setup/useSetup'

const { selectedPartner } = useSetup()
const { activePartnersData } = usePartners(selectedAccommodationId)
const partnersOptions = computed(() => {
  return (activePartnersData.value || [])
    ?.filter(item => item.canNetCpa)
    .map(partnerItem => {
      return {
        value: partnerItem.partnerId,
        displayText: partnerItem.partnerName,
      }
    })
})
const setSelectedPartner = partnerId => {
  const findSelectedPartner = partnersOptions.value?.find(item => item.value === Number(partnerId))
  if (findSelectedPartner) {
    selectedPartner.value = findSelectedPartner
  }
}

watch(
  partnersOptions,
  newOptions => {
    if (newOptions?.length > 0 && !selectedPartner.value) {
      selectedPartner.value = newOptions[0]
    }
  },
  { immediate: true }
)
</script>
